import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { tabletQuery } from '../../../utils';
import { useTextVariant } from '../../../hook/useTextVariant';
import { HEADER_CONSTANTS } from '../../../constants/header';

export const HeaderPc = () => {
  const { getText } = useTextVariant(HEADER_CONSTANTS, false);

  return (
    <>
      <LogoContainer>
        <Logo src={ImageUtils.Logo} />
      </LogoContainer>
      <TableContainer>
        <TopHeaderRow>
          <TopHeader>{getText('satelliteTitle')}</TopHeader>
          <TopHeader>{getText('mainEventTitle')}</TopHeader>
        </TopHeaderRow>
        <TableGroup>
          <GroupHeader>{getText('satelliteTitle')}</GroupHeader>
          <TableBody>
            <TableColumn>
              <TableCell1>
                <TableDateText>
                  {getText('satelliteDate1')}
                  <br />
                  <span>{getText('satelliteTime1')}</span>
                </TableDateText>

                <TableDateText>
                  {getText('satelliteDate2')}
                  <br />
                  <span>{getText('satelliteTime2')}</span>
                </TableDateText>
              </TableCell1>
            </TableColumn>
            <Divider />
            <TableColumn>
              <TableCell1>
                <CenterRow>
                  <img src={ImageUtils.ShowDownApp} alt="ShowDownApp" />
                  <TableBottomText>{getText('satelliteApp')}</TableBottomText>
                </CenterRow>
              </TableCell1>
            </TableColumn>
          </TableBody>
        </TableGroup>
        <GroupDivider />
        <TableGroup>
          <GroupHeader>{getText('mainEventTitle')}</GroupHeader>
          <TableBody>
            <TableColumn>
              <TableCell1>
                <TableDayText>{getText('mainEventDay')}</TableDayText>
              </TableCell1>
            </TableColumn>
            <Divider />
            <TableColumn>
              <TableCell1>
                <CircleText>{getText('mainEventVenue')}</CircleText>
                <LocationText>{getText('mainEventDetail')}</LocationText>
              </TableCell1>
            </TableColumn>
          </TableBody>
        </TableGroup>
      </TableContainer>
    </>
  );
};

const Logo = styled.img`
  width: 550px;
`;

const LogoContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 14px;
  padding-top: 18px;
`;

const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 14px;
  position: relative;

  ${tabletQuery} {
    flex-wrap: wrap;
  }
`;

const TableGroup = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`;

const GroupHeader = styled.div`
  display: flex;
  flex: 0 0 100%;
  background: #2c52b3;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
  color: rgba(255, 255, 255, 0.8);
  height: 35px;
  text-align: center;
  font-weight: 400;
  font-size: 20px;
  align-items: center;
  justify-content: center;

  ${tabletQuery} {
    display: none;
  }
`;

const TopHeaderRow = styled.div`
  display: none;
  width: 100%;

  ${tabletQuery} {
    display: flex;
    flex-direction: row;
    flex: 0 0 100%;
  }
`;

const TopHeader = styled(GroupHeader)`
  ${tabletQuery} {
    display: flex;
    flex: 1;
  }
`;

const TableBody = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  position: relative;

  ${tabletQuery} {
    flex-direction: column;
  }
`;

const TableColumn = styled.div`
  flex: 1;

  ${tabletQuery} {
    &:first-child > * {
      height: 100px;
    }
  }
`;

const TableCell = styled.div`
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  letter-spacing: -0.05em;
  color: rgba(255, 255, 255, 0.7);
`;

const TableCell1 = styled(TableCell)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 106px;

  ${tabletQuery} {
    height: 90px;
  }
`;

const Divider = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  height: 30px;
  background: rgba(117, 165, 255, 0.2);
  pointer-events: none;
  z-index: 1;

  ${tabletQuery} {
    display: none;
  }
`;

const GroupDivider = styled.div`
  position: absolute;
  left: 50%;
  top: calc(35px + 53px);
  transform: translate(-50%, -50%);
  width: 2px;
  height: 30px;
  background: rgba(117, 165, 255, 0.2);
  pointer-events: none;
  z-index: 1;

  ${tabletQuery} {
    display: none;
  }
`;

const CenterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    margin-right: 10px;
  }

  margin-bottom: 14px;
  margin-top: 14px;
`;

const TableDateText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  white-space: pre-wrap;

  span {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  }

  ${tabletQuery} {
    margin-top: 0;
  }
`;

const TableDayText = styled(TableDateText)`
  font-size: 22px;
  span {
    color: rgba(255, 255, 255, 0.8);
    font-size: 20px;
  }
`;

const TableBottomText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  white-space: pre-wrap;
`;

const CircleText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  display: inline-block;
  text-align: center;
  font-size: 18px;
  line-height: 31px;

  height: 35px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 30px;
  margin-bottom: 4px;

  padding-left: 20px;
  padding-right: 20px;
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
`;
